import CourseAdmin from "./CourseAdmin.vue";
import CourseCertificate from "./CourseCertificate.vue";
import CourseGenerator from "./CourseGenerator.vue";
import CoursePlayer from "./CoursePlayer.vue";
import Courses from "./Courses.vue";

const lock = (user) => [user?.Security?.General?.Training !== true, "Cannot view this area"];

export default [{
    path: "/Matrices/Courses",
    component: Courses,
    name: "Training Courses",
    meta: {
        app: "Matrices",
        name: "Training Courses",
        sideNav: true,
        sideNavPosition: 14,
        sideNavSection: "Staff Training",
        appSwitcher: false,
        icon: "book",
        addToRecents: false,
        lock,
        show: ( user ) => {
            return user.Basic?.showBetaFeatures === true;
        }
    },
}, {
    path: "/Matrices/Courses/new",
    component: CourseGenerator,
    name: "New Training Course",
    meta: {
        app: "Matrices",
        name: "New Training Course",
        sideNav: false,
        appSwitcher: false,
        addToRecents: false,
        lock,
    },
}, {
    path: "/Matrices/Courses/:id/play",
    component: CoursePlayer,
    name: "Play Training Course",
    meta: {
        app: "Matrices",
        name: "Training Course",
        sideNav: false,
        appSwitcher: false,
        addToRecents: false,
        lock,
    },
}, {
    path: "/Matrices/Courses/:id/certificate",
    component: CourseCertificate,
    name: "Training Course Certificate",
    meta: {
        app: "Matrices",
        name: "Course certificate",
        sideNav: false,
        appSwitcher: false,
        addToRecents: false,
        lock,
    },
}, {
    path: "/Matrices/Courses/:id",
    component: CourseAdmin,
    name: "Training Course",
    meta: {
        app: "Matrices",
        name: "Training Course",
        sideNav: false,
        appSwitcher: false,
        addToRecents: false,
        lock,
    },
}];
